import { bindTypesToActions } from '@src/utils/redux_utils';
import defaultIcon from '@src/assets/icons/profileicon.png';
import { types as coretypes } from '@src/store';


const types={
    //sage actions:
    GetAvatars:'AVATAR_FETCH',
   
   // reducer actions
    SetAvatars:'AVATARS_SET',
    SetCurrent:'AVATAR_SET_CURRENT'
}

const AvatarActions = bindTypesToActions( types );

const defaultAvatar = {
    castncrewid: 'fallback-profile-id',
    imagelink: defaultIcon,
    mode: "PUBLIC"
}

const initialState={
    list: [ defaultAvatar ],
    current: defaultAvatar.castncrewid
}

const AvatarReducer = ( state = initialState, { type, payload } ) => {
    switch(type){
        case types.SetAvatars:
            const { avatars } = payload ;
            if( !Array.isArray( avatars ) )return state ;
            return {
                ...state,
                list: [ defaultAvatar, ...avatars ]
            }
        case types.SetCurrent:
            const { avatarid } = payload ;
            if( !avatarid )return state ;
            return {
                ...state,
                current: avatarid
            }
        case coretypes.profile.SelectProfile:
            const profile = payload ;
            if( !profile.avatarid )return state ;
            return {
                ...state,
                current: profile.avatarid
            }
        default: return state;    
    }
}

export {
    types as AvatarTypes,
    AvatarReducer,
    AvatarActions
}